import React from 'react';
import {Row, Col, Dropdown, Menu} from 'antd';
import {t} from "../utils/i18n";
import {enquireScreen} from "enquire-js";
import {connect} from "react-redux";
import {injectIntl} from "react-intl";
import {setLanguage} from "../actions/app";

let isMobile;

enquireScreen((b) => {
    isMobile = b;
});

const _style = isMobile ? {display: 'flex', flexDirection: 'column', textAlign: 'center'} : {
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'left'
}

class Footer extends React.Component {
    constructor(props) {
        super(props);
    }
    onLanguageClick = ({key}) => {
        this.props.setLanguage(key);
    };
    render() {
        let {activeLanguage} = this.props;
        const language = (
            <Menu onClick={this.onLanguageClick}>
                <Menu.Item key="en">English</Menu.Item>
                <Menu.Item key="zh">中文</Menu.Item>
            </Menu>
        );
        return (
            <>
                <div className='bg-black'>
                    <div className='_container'>
                        <div className='pt-5-rem partners'>{t('partners')}</div>
                        <div className='flex justify-between partners_logo pt-3-rem pb-3-rem'>
                            <div>
                                <a href='https://tron.network' target='_blank' rel='noreferrer'><img className='img1' alt='tron'
                                                                                    src={require('../images/tron.png').default}/></a>
                            </div>
                            <div>
                                <a href='https://www.apenft.org' target='_blank' rel='noreferrer'><img className='img2' alt='apenft'
                                                                                      src={require('../images/apenftlogo.png').default}/></a>
                            </div>
                            <div>
                                <a href='https://www.bittorrent.com' target='_blank' rel='noreferrer'><img className='img3' alt='bittorrent'
                                                                                          src={require('../images/bift.png').default}/></a>
                            </div>
                            <div>
                                <a href='https://winklink.org' target='_blank' rel='noreferrer'><img className='img5' alt='winklink'
                                                                                    src={require('../images/win.png').default}/></a>
                            </div>
                        </div>
                    </div>
                </div>
                <footer id="footer" className='dark'>
                    <Row className="bottom-bar _container"
                         style={isMobile ? {padding: '20px 10px'} : {padding: '20px 0px'}}>
                        <Col className='col' lg={6} xs={8}>
                            <div style={_style} className='_items'>
                                <div style={{fontSize: '16px', opacity:'0.5'}}><strong>{t('ecosystem')}</strong></div>

                                <div>
                                    <a href="https://tron.network/" target="_blank" rel='noreferrer'> TRON </a>
                                </div>
                                <div>
                                    <a href="https://www.bittorrent.com/token/bittorrent-file-system/"
                                       target="_blank" rel='noreferrer'> BTFS </a>
                                </div>
                                <div>
                                    <a href="https://www.apenft.org" target="_blank" rel='noreferrer'> APENFT </a>
                                </div>
                                <div>
                                    <a href="https://www.tronlink.org" target="_blank" rel='noreferrer'> TronLink </a>
                                </div>
                            </div>
                        </Col>
                        <Col className='col' lg={6} xs={8}>
                            <div style={_style} className='_items'>
                                <div style={{fontSize: '16px', opacity:'0.5'}}><strong>{t('developer')}</strong></div>

                                <div>
                                    <a href="https://github.com/TRON-US/go-btfs" target="_blank" rel='noreferrer'> BTFS Github </a>
                                </div>
                                <div>
                                    <a href="https://docs.btfs.io/" target="_blank" rel='noreferrer'> BTFS Doc </a>
                                </div>
                            </div>
                        </Col>
                        <Col className='col' lg={6} xs={8}>
                            <div style={_style} className='_items'>
                                <div style={{fontSize: '16px', opacity:'0.5'}}><strong>{t('community')}</strong></div>

                                <div>
                                    <a href="https://t.me/BTTBitTorrent" rel="noopener noreferrer" target="_blank">
                                        Telegram
                                    </a>
                                </div>
                                <div>
                                    <a href="https://discord.gg/VmMjp2gvAB" rel="noopener noreferrer" target="_blank">
                                        Discord
                                    </a>
                                </div>
                                <div>
                                    <a href="https://twitter.com/BitTorrent" rel="noopener noreferrer" target="_blank">
                                        Twitter
                                    </a>
                                </div>
                                <div style={{whiteSpace: 'nowrap', opacity:'0.5'}}>
                                    <span> WeChat {': BTTService02'} </span>
                                </div>
                            </div>
                        </Col>

                        <Col lg={6} xs={24}>
                            <div style={{
                                textAlign: 'center',
                                marginBottom: '10px',
                                whiteSpace: 'nowrap',
                                marginTop: '15px'
                            }}>
                                <img className='inline footer_logo' src='logo.png' alt="logo"/>
                                <div className='slogan'>
                                    {t('home_sub_title')}
                                </div>
                            </div>

                            {isMobile && <Dropdown overlay={language} placement='topCenter' className="ml-4-rem"
                                                   overlayClassName="lang">
                                <div className={"m-0-auto items-center flex " + (activeLanguage==="en" ? "en" : "zh")} onClick={e => e.preventDefault()}></div>
                            </Dropdown>}
                        </Col>
                    </Row>

                </footer>
            </>
        );
    }
}

function mapStateToProps(state) {
    return {
        activeLanguage: state.app.activeLanguage,
    };
}

const mapDispatchToProps = {
    setLanguage,
};



export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(Footer))
